import type { EventBus } from '@engine/EventBus'
import type { Deck } from '@interfaces/index'

/**
 * IUIBridge decouples the game layer (Phaser scenes) from the UI layer (Zustand stores).
 * The game layer calls getUIBridge() instead of importing stores directly, keeping
 * dependency direction strictly downward (Layer 1 → not Layer 3).
 *
 * Initialised in main.ts (composition root) via initUIBridge() before Phaser starts.
 */
export interface IUIBridge {
  setLoading(progress: number, message: string): void
  setLoadingDone(): void
  setEventBus(bus: EventBus, startHp?: number, localPlayerId?: string): void
  tickRemainingMs(remainingMs: number): void
  getGameMode(): 'pvp' | 'bot' | 'campaign' | 'coop'
  getMatchmakingMatchId(): string | null
  getDeck(deckId: string): Deck | undefined
  updateQuestProgress(
    progress: Array<{
      questId: string
      progress: number
      completed: boolean
      claimedReward: boolean
    }>
  ): void
}

let _bridge: IUIBridge | null = null

export function initUIBridge(bridge: IUIBridge): void {
  _bridge = bridge
}

export function getUIBridge(): IUIBridge {
  if (_bridge === null) {
    throw new Error('[UIBridge] Not initialised — call initUIBridge() before Phaser starts')
  }
  return _bridge
}
